<div class="summary-main">
	<div class="summary-header">
		<i class="summary-icon icon-front"></i>
		<div class="name-and-size">
			<div class="name">
				<h4>{{modelCode}}</h4>
			</div>
			<div class="model-size" [innerHTML]="modelSize | replaceHash"></div>
		</div>
	</div>

	@for (variant of variantsToShow; track $index) {
	<div class="component">
		<div>
			<i [ngClass]="'summary-icon icon-' + icons.get(variant.ComponentCode ? variant.ComponentCode: '') "></i>
		</div>
		<div class="values">
			<b>{{'CUSTOMIZER.COMPONENTS.' + variant.ComponentCode + '.NAME' | translate}}</b>

			@if (!variant.ComponentVariantByPass) {
			<div class="split">
				<div>{{ 'DOMAIN.COMPONENT-DESCRIPTIONS.DESIGN' | translate }}</div>
				<div>
					{{variant.ComponentDescription | dataTranslate | translate }}
					{{variant.ComponentDescription2 | dataTranslate | translate }}
				</div>

				@if (variant.ComponentVariantOptional && (!variant.VariantSize)) {
				{{'COMMON.NONE' | translate}}
				}
			</div>
			}

			@if (variant.ComponentVariantSizeDescription?.toLowerCase()?.indexOf('fixed') === -1) {
			<div class="split">
				<div>{{ 'DOMAIN.COMPONENT-DESCRIPTIONS.SIZE' | translate }}</div>
				<div>{{variant.ComponentVariantSizeDescription}}</div>
			</div>
			}

			@if (variant.ComponentCode === 'TEMPLE' && templeInclination !== null && templeInclination !== undefined) {
				<div class="split">
					<div>{{ 'BAG.TEMPLE.INCLINATION' | translate }}</div>
					<div>{{ templeInclinationTranslationKey | translate }}</div>
				</div>
			}

			<div class="split">
				@if (variant.ComponentCode !== 'BRIDGE_CLIP' && variant.VariantColor && variant.VariantColor.Color?.ColorLine?.Code) {
				<div>{{ 'DOMAIN.COMPONENT-DESCRIPTIONS.COLOR' | translate }}</div>
				<app-combined-color-name [color]="variant.VariantColor.Color" [variantColor]="variant.VariantColor" [forceDescriptionOnly]="(variant.VariantColor.Color?.ColorLine?.Code !== 'HORN') && (variant.VariantColor.Color?.ColorLine?.Code === 'SUN')"></app-combined-color-name>
				}

				@if (!variant.VariantColor && !variant.ComponentVariantByPass && !variant.ComponentVariantSizeBypass) {
				{{'CUSTOMIZER.COMPONENTS.COLOR.NOCOLOR' | translate}}
				}
			</div>
		</div>
	</div>
	}

	@if (engraving) {
	<div class="component">
		<div>
			<i class="summary-icon icon-engraving"></i>
		</div>
		<div class="values">
			<b>{{'CUSTOMIZER.COMPONENTS.ENGRAVING.NAME' | translate}}</b>
			<div>
				{{engraving}}
			</div>
		</div>
	</div>
	}

</div>